import type { Language } from '../types/language';

export function buildStructuredData(language: Language): Record<string, unknown>[] {
  const isSpanish = language === 'es';
  const person = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Leonardo Tovar',
    jobTitle: isSpanish ? 'Bailarín, Coreógrafo, Performer y Coach de baile' : 'Dancer, Choreographer, Performer & Dance Coach',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Denver',
      addressRegion: 'CO',
      addressCountry: 'US',
    },
  };

  const service = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: isSpanish ? 'Leonardo Tovar — Baile, Coreografía y Coaching' : 'Leonardo Tovar — Dance, Choreography & Coaching',
    description: isSpanish ? 'Clases profesionales de baile, coaching, coreografía y experiencias de performance en Denver.' : 'Professional dance classes, coaching, choreography and performance experiences in Denver.',
    areaServed: ['Denver, CO', 'Denver Metro Area', 'Colorado'],
    provider: { '@type': 'Person', name: 'Leonardo Tovar' },
    makesOffer: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: isSpanish ? 'Clases privadas y coaching de baile' : 'Private Dance Classes & Coaching' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: isSpanish ? 'Coreografía para bodas y quinceañeras' : 'Wedding & Quinceañera Choreography' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: isSpanish ? 'Coaching para grupos y competencias' : 'Group & Competition Coaching' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: isSpanish ? 'Performances para eventos corporativos' : 'Corporate Event Performances' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: isSpanish ? 'Coreografía personalizada' : 'Custom Choreography' } },
    ],
  };

  return [person, service];
}
